.seeAllButton {
  border-radius: 4px;
  color: rgb(185, 185, 185);
  display: inline-flex;
  align-items: center;
  font: var(--font-body-sm-medium);
  height: 32px;
  text-align: center;
  text-decoration: none;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  width: 65px;
  justify-content: space-between;

  svg {
    height: 18px;
    width: 18px;
    margin-top: -1px;
    vertical-align: middle;
    position: relative;
    transform: scale(-1, 1);

    path {
      transition: all .3s ease;
      stroke: rgb(185, 185, 185);
    }
  }

  &:hover {
    color: var(--primitives-colors-brand-secondary);

    svg {
      path {
        stroke: var(--primitives-colors-brand-secondary);
      }
    }
  }
}
